import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient.js';
import { useStateContext } from '../../Contexts/ContextProvider.jsx';
import SpeakerRow from './SpeakerRow.jsx';
import ConferenceDropdown from '../../Forms/ConferenceDropdown.jsx';
import Loader from '../../assets/tools/Loder/loader';
import { DataTable, PageHeader, PageToolbar } from '../../componants/Workspace';

const Speakers = () => {
  const [speakers, setspeakers] = useState([]);
  const [conferenceId , setConferenceId] = useState(null) ; 
  const { SetNotification } = useStateContext();
  const [loading, setLoading] = useState(true);

  useEffect(() => { 
    const controller = new AbortController () ; 
    const signal = controller.signal ; 

    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await AxiosClient.get(`/conference/${conferenceId}/speakers`);
        setspeakers(response.data);
        setLoading(false);
      } catch (error) {

        if (error.name === 'CanceledError') {
          console.log('Request aborted');
          return; // Ignore the error if the request was aborted
        }

        console.error(error);
        SetNotification('Error fetching data', 'danger');
      }
    };
    fetchData(); 

    return () => {
      controller.abort(); // Abort the previous request when conferenceId changes
    };

  }, [conferenceId]);

  const handleDeletespeaker = async (id) => {
    try {
    await AxiosClient.delete(`/speakers/${id}`);
      setspeakers(speakers.filter(speaker => speaker.id !== id));
      SetNotification('A speaker has been deleted', 'success');
    } catch (error) {
      console.error(error);
      SetNotification('Error while deleting the speaker', 'danger');
    }
  };

  return (
    <>
      <PageHeader
        title="Speakers"
        description="Manage speaker profiles and presentation order."
        actions={conferenceId && (
          <>
            <Link className="btn btn-primary" to={`./Add/${conferenceId}`}>
              <i className="material-icons" aria-hidden="true">add</i>
              Add speaker
            </Link>
            <Link className="btn btn-outline-secondary" to={`./sort/${conferenceId}`}>
              <i className="material-icons" aria-hidden="true">sort</i>
              Edit order
            </Link>
          </>
        )}
      />
      <PageToolbar filters={<ConferenceDropdown conferenceId={conferenceId} setConferenceId={setConferenceId} />} />

      {!conferenceId ? (
        <div className="workspace-empty">Select a conference to manage its speakers.</div>
      ) : loading ? (
        <div className="workspace-loading"><Loader label="Loading speakers..." /></div>
      ) : speakers && speakers.length > 0 ? (
        <DataTable>
                  <thead className="table-light">
                    <tr>
                      <th className="ps-4">Name</th>
                      <th>Title</th>
                      <th>Description</th>
                      <th>Image</th>
                      <th className="pe-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {speakers.map((speaker) => (
                      <SpeakerRow
                        key={speaker.id}
                        name={speaker.name}
                        title={speaker.title}
                        description={speaker.description}
                        image={speaker.image}
                        id={speaker.id}
                        onDelete={handleDeletespeaker}
                      />
                    ))}
                  </tbody>
        </DataTable>
      ) : (
        <div className="workspace-empty">No speakers found for this conference.</div>
      )}
    </>
  );
};

export default Speakers;
